











































import { Vue, Component, Prop } from "vue-property-decorator";


// import SignMessageMultiple from '../components/SignMessageMultiple.vue';
import AvaToHex from "../components/AvaToHex.vue"
import AvaToHexV2 from "../components/AvaToHexV2.vue"
import UnformatHex from "@/components/UnformatHex.vue";
import PrivateToPublic from "../components/PrivateToPublic.vue";
import DeriveAddresses from "@/components/DeriveAddresses.vue";
import DerivePrivKeys from "@/components/DerivePrivKeys.vue";

// const slopes = require("slopes");
// let avalanche = require('avalanche');

import {Buffer} from 'avalanche';
import {avm} from "@/AVA";
import BinTools from "avalanche/dist/utils/bintools";


let bintools = BinTools.getInstance()



let myKeychain = avm.keyChain();
let keypair = myKeychain.makeKey();

// let ch = new avalanche.CryptoHelpers();

@Component({
  name: 'Home',
  components: {
    // SignMessageMultiple,
    AvaToHex,
    AvaToHexV2,
    UnformatHex,
    PrivateToPublic,
    DeriveAddresses,
    DerivePrivKeys
  }
})
export default class Home extends Vue{
  comp_1_in: string = "";
  comp_1_out: string = "";

  comp_2_in: string = "";
  comp_2_out: string = "";

  comp_3_in: string = "";
  comp_3_out: string = "";

  comp_4_in_1: string = "I am the very model of a modern major general.";
  comp_4_in_2: string = "";
  comp_4_out: string = "";


  hexTob58(){
    try{
      let buf = Buffer.from(this.comp_1_in, 'hex');
      this.comp_1_out = bintools.cb58Encode(buf);
    }catch(e){
      this.comp_1_out = e;
    }
  }
  cleanHex(){
    let arr = this.comp_2_in.match(/.{1,2}/g)
    // arr.join(" ")
    this.comp_2_out = arr!.join(' ');
  }
  privKeyToAddress(){
    //does not add X- or P- prefix
    let b58PrivateKey = this.comp_3_in;
    let mypk = bintools.cb58Decode(b58PrivateKey);
    let keypair = myKeychain.importKey(mypk);
    let addrStr = keypair.getAddressString()
    this.comp_3_out = addrStr;
  }
  // messageRecover(){
  //   let msg = this.comp_4_in_1;
  //   let sig = this.comp_4_in_2;
  //   let msgBuff = Buffer.from(ch.sha256(msg), 'utf8');
  //   let signedBuff = bintools.avaDeserialize(sig);
  //   let pubKey = keypair.recover(ch.sha256(msg), signedBuff);
  //   let addressBuff = keypair.addressFromPublicKey(pubKey);
  //   let address = bintools.avaSerialize(addressBuff);
  //   this.comp_4_out = address;
  // }
}
